module.exports = __webpack_public_path__ + "static/media/2XL.d3cab8ba.jpg";